export default "__VITE_ASSET__Cjea65PX__"